module.exports = __webpack_public_path__ + "img/disneyb.2da31eab.png";